module.exports = {
      id: "cancel-usage",
      viewBox: "0 0 241.171 241.171",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#cancel",
      toString: function () {
        return this.url;
      }
    }